import { httpRequest } from '../../../../app/common/util/api-common.util';

class CongelacaoAPI {
  static cancelamentoCongelacao(laudo, justificativa) {
    return httpRequest(
      `laudos/${laudo}/etapas/congelacao/cancelamento`,
      'PATCH',
      {
        justificativa: justificativa,
      }
    ).then((json) => json.data);
  }
}

export default CongelacaoAPI;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/congelacao/congelacao.api.js